export default __webpack_public_path__ + "static/media/Finit_logo.db07d719.png";